import { render } from "./Terms.vue?vue&type=template&id=6a9b6b66&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=6a9b6b66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a9b6b66"

export default script